import { render, staticRenderFns } from "./ItemUpdate.vue?vue&type=template&id=13afbfd6&scoped=true"
import script from "./ItemUpdate.vue?vue&type=script&lang=ts"
export * from "./ItemUpdate.vue?vue&type=script&lang=ts"
import style0 from "./ItemUpdate.vue?vue&type=style&index=0&id=13afbfd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13afbfd6",
  null
  
)

export default component.exports